module.exports = __webpack_public_path__ + "img/retired-2-min.d7ec8448.jpg";